const AccountType = Object.freeze({
  CareGiver: '1',
  Patient: '2',
});

export default AccountType;
